var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReqEhuGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_417",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 26,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 26,
    height: 26,
    rx: 0.5,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_417)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1769 25.7708C11.7924 25.7708 11.5518 25.3548 11.7435 25.0215L15.3091 18.8243C15.4882 18.513 15.2905 18.1201 14.9339 18.0783L8.43203 17.3163C8.00468 17.2663 7.83597 16.7356 8.15592 16.4479L19.3783 6.35732C19.47 6.27479 19.5891 6.22913 19.7126 6.22913H19.8557C20.2422 6.22913 20.4826 6.64906 20.2868 6.98238L16.6395 13.1911C16.4563 13.503 16.6546 13.9002 17.014 13.9412L23.5627 14.6867C23.991 14.7355 24.161 15.2671 23.8404 15.5553L12.6217 25.6426C12.5299 25.7252 12.4109 25.7708 12.2874 25.7708H12.1769Z",
    fill: "#ADAAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReqEhuGrey);
export default __webpack_public_path__ + "static/media/req_EHU_grey.8c7b9d1ce0a9717dc21d2dd7bac965a1.svg";
export { ForwardRef as ReactComponent };